import {
  ICreateConnectionRequestMessage,
  ICreateEquipmentGroupMessage,
  ICreateEquipmentMessage,
  ICreateParameterGroupMessage,
  ICreateParameterMessage,
  IIncidentCreatedMessage,
  IDeleteEquipmentGroupMessage,
  IDeleteEquipmentMessage,
  IDeleteParameterGroupMessage,
  IDeleteParameterMessage,
  IUpdateEquipmentGroupMessage,
  IUpdateEquipmentMessage,
  IUpdateParameterGroupMessage,
  IUpdateParameterMessage,
  IUserNotificationMessage,
} from './ws.types'
import equipmentEvents from '../../pages/Equipment/events/equipment/equipment.events.ts'
import equipmentGroupsEvents from '../../pages/Equipment/events/groups/groups.events.ts'
import parameterGroupsEvents from '@/pages/Parameters/events/groups/paramterGroups.events.ts'
import parameterEvents from '@/pages/Parameters/events/parameter/parameter.events.ts'
import notificationService from '../Notification/notification.service.ts'

const equipment = {
  create: (msg: ICreateEquipmentMessage) => equipmentEvents.created(msg.payload),
  update: (msg: IUpdateEquipmentMessage) => equipmentEvents.updated(msg.payload),
  delete: (msg: IDeleteEquipmentMessage) => equipmentEvents.deleted(msg.payload.id),
}

const equipmentGroups = {
  create: (msg: ICreateEquipmentGroupMessage) => equipmentGroupsEvents.created(msg.payload),
  update: (msg: IUpdateEquipmentGroupMessage) => equipmentGroupsEvents.updated(msg.payload),
  delete: (msg: IDeleteEquipmentGroupMessage) => equipmentGroupsEvents.deleted(msg.payload.id),
}

const lifts = {
  create: (msg: ICreateConnectionRequestMessage) => equipmentEvents.connectionRequestCreated(msg.payload),
}

const parameters = {
  create: (msg: ICreateParameterMessage) => parameterEvents.created(msg.payload),
  update: (msg: IUpdateParameterMessage) => parameterEvents.updated(msg.payload),
  delete: (msg: IDeleteParameterMessage) => parameterEvents.deleted(msg.payload.id),
}

const parameterGroups = {
  create: (msg: ICreateParameterGroupMessage) => parameterGroupsEvents.created(msg.payload),
  update: (msg: IUpdateParameterGroupMessage) => parameterGroupsEvents.updated(msg.payload),
  delete: (msg: IDeleteParameterGroupMessage) => parameterGroupsEvents.deleted(msg.payload.id),
}

const incidents = {
  create: (msg: IIncidentCreatedMessage) =>
    notificationService.notificationReceived({ type: 'ALARM_SITUATION_INCIDENT', payload: msg.payload }),
}

const notification = {
  create: (msg: IUserNotificationMessage) =>
    notificationService.notificationReceived({ type: msg.payload.type, payload: msg.payload }),
}

/*
const alarmSituations = {
  create: (msg: ICreateAlarmSituationMessage) => alarmSituationsEvents.created(msg.payload),
  update: (msg: IUpdateAlarmSituationMessage) => alarmSituationsEvents.updated(msg.payload),
  delete: (msg: IDeleteAlarmSituationMessage) => alarmSituationsEvents.deleted(msg.payload.id),
}

const dashboards = {
  create: (msg: ICreateDashboardMessage) => dashboardsEvents.created(msg.payload),
  update: (msg: IUpdateDashboardMessage) => dashboardsEvents.updated(msg.payload),
  delete: (msg: IDeleteDashboardMessage) => dashboardsEvents.deleted(msg.payload.id),
}*/

const handlers = {
  equipment,
  equipmentGroups,
  parameters,
  parameterGroups,
  lifts,
  incidents,
  notification,
}
export default handlers
